export default __webpack_public_path__ + "media/ClinicalOralHeroImageDesktop.36b38522e3611f5d5335496bda3de592.webp";